import { gql } from '@apollo/client';

export const DELETE_VIRTUAL_HOTEL_USER_PROFILE = gql`
  mutation DeleteVirtualHotelUserProfile($data: deleteVirtualHotelUserInput) {
    deleteVirtualHotelUser(input: $data) {
      virtualHotelUser {
        id
      }
    }
  }
`;
